import './Map.css'

import React, { Component } from 'react'
import Helmet from 'react-helmet'
import _debounce from 'lodash/debounce'

export default class GoogleMap extends Component {
    static defaultProps = {
        apiKey: '',
        lat: -28.106237,
        lng: 153.425939,
        zoom: 15,
        disableDefaultUI: true,
        icon: '/images/map-marker.png',
        styles: '[ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ]'
    }

    mapElement = null
    map = null

    componentDidMount() {
        window.initMap = this.initMap
        if (window.google) this.initMap()
        this.addListeners()
    }

    addListeners = () => {
        if (!this.map) return false
        window.addEventListener('resize', _debounce(this.setMapCenter), 100)
    }

    setMapCenter = () => {
        if (!this.map) return false
        const { lat, lng } = this.props
        const center = { lat, lng }
        this.map.setCenter(center)
        // this.panMapOffset()
    }

    // panMapOffset = () => {
    //   if (!this.map || window.innerWidth <= 1000) return false
    //   this.map.panBy(window.innerWidth / 5, 0)
    // }

    initMap = () => {
        const google = window.google
        const { lat, lng, zoom, disableDefaultUI } = this.props
        const styles = JSON.parse(this.props.styles)
        const center = { lat, lng }
        const map = new google.maps.Map(this.mapElement, {
            zoom,
            disableDefaultUI,
            styles
        })
        // pan offset
        const icon = this.props.icon
            ? {
                url: this.props.icon
            }
            : ''
        this.marker = new google.maps.Marker({
            position: center,
            icon,
            map
        })

        this.map = map
        this.setMapCenter()
        this.addListeners()
    }

    render() {
        return (
            <div className='GoogleMap--Wrap'>
                <Helmet>
                    <script
                        async
                        defer
                        src={`https://maps.googleapis.com/maps/api/js?key=AIzaSyD2IaOzZqN9K2ddbd9L8vxQSx3oHWJJoes&callback=initMap`}
                    />
                </Helmet>
                <div
                    className='GoogleMap'
                    ref={el => {
                        this.mapElement = el
                    }}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Map.js